import { render, staticRenderFns } from "./2026edukorea.vue?vue&type=template&id=3b9b0b28&scoped=true"
import script from "./2026edukorea.vue?vue&type=script&lang=js"
export * from "./2026edukorea.vue?vue&type=script&lang=js"
import style0 from "./2026edukorea.vue?vue&type=style&index=0&id=3b9b0b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b0b28",
  null
  
)

export default component.exports